import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IFilterPurchase, IPurchaseDetail } from "../purchaseModal";
import moment from "moment";

// Get all purchases with optional filters
export const getAllPurchases = createAsyncThunk(
  "PurchaseForm/FindAllPurchaseForm",
  async (formData: IFilterPurchase) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PurchaseForm/FindAllPurchaseForm`,
        formData,
      );
      return response.data?.Data?.length > 0
        ? response.data.Data?.map((Item: any) => ({
            ...Item,
            Date: Item.Date
              ? moment(Item.Date, "YYYY-MM-DD").format("DD/MM/YYYY")
              : "",
          }))
        : [];
    } catch (error: any) {
      console.error("Error Fetching Purchases:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Create a new purchase
export const createPurchase = createAsyncThunk(
  "PurchaseForm/InsertPurchaseForm",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PurchaseForm/InsertPurchaseForm`,
        formData,
      );
      SuccessToast(response.data?.Details || "Purchase created successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Creating Purchase:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Update an existing purchase
export const updatePurchase = createAsyncThunk(
  "PurchaseForm/UpdatePurchaseForm",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PurchaseForm/UpdatePurchaseForm`,
        formData,
      );
      SuccessToast(response.data?.Details || "Purchase updated successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Updating Purchase:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
// Get purchase by ID
export const getPurchaseById = createAsyncThunk(
  "PurchaseForm/FindByIDPurchaseForm",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PurchaseForm/FindByIDPurchaseForm`,
        { ID },
      );
      const result = response.data?.Data;

      // Transform to match the new interface structure with PurchaseForm array
      return {
        ID: result.ID,
        Date: result.Date ? moment(result.Date).toDate() : moment().toDate(),
        VeparyID: result.VeparyID,
        InvoiceNo: result.InvoiceNo,
        PurchaseType: result.PurchaseForm[0]?.PurchaseType
          ? result.PurchaseForm[0]?.PurchaseType
          : "Antique",
        IsActive: result.IsActive === true ? 1 : 2,
        PurchaseForm:
          result?.PurchaseForm &&
          Array.isArray(result.PurchaseForm) &&
          result.PurchaseForm.length > 0
            ? result.PurchaseForm.map((purchaseForm: any) => ({
                PurchaseType: purchaseForm.PurchaseType,
                id: purchaseForm.id,
                Date: result.Date,
                VeparyID: result.VeparyID,
                InvoiceNo: result.InvoiceNo,
                ProductID: purchaseForm.ProductID,
                PCS: purchaseForm.PCS,
                BagNo: purchaseForm.BagNo,
                ProductCategoryID: purchaseForm.ProductCategoryID,
                ProductSubCategoryID: purchaseForm.ProductSubCategoryID,
                UniqueProductID: purchaseForm.UniqueProductID,
                GrossWeight: purchaseForm.GrossWeight,
                NetWeight: purchaseForm.NetWeight,
                Wastage: purchaseForm.Wastage,
                PhinePayble: purchaseForm.PhinePayble,
                TotalRSPayable: purchaseForm.TotalRSPayable,
                DiamondWeight: purchaseForm.DiamondWeight,
                LabelLessWtForDiamond: purchaseForm.LabelLessWtForDiamond,
                DiamondChargesPerCt: purchaseForm.DiamondChargesPerCt,
                DiamondChargesTotal: purchaseForm.DiamondChargesTotal,
                PerCaretDiamondCharges: purchaseForm.PerCaretDiamondCharges,
                OtherStoneWeight: purchaseForm.OtherStoneWeight,
                LabelLessWeightForStone: purchaseForm.LabelLessWeightForStone,
                OtherChargesChargeBySupplier:
                  purchaseForm.OtherChargesChargeBySupplier,
                OtherChargesForLable: purchaseForm.OtherChargesForLable,
                LabourPerGram: purchaseForm.LabourPerGram,
                TotalLabour: purchaseForm.TotalLabour,
                LessWeight: purchaseForm.LessWeight,
                LessWeightForLabel: purchaseForm.LessWeightForLabel,
                OtherCharges: purchaseForm.OtherCharges,
                LabourChargesForLabel: purchaseForm.LabourChargesForLabel,
                Remarks: purchaseForm.Remarks,
                StoneBagNo: purchaseForm.StoneBagNo,
                GMCT: purchaseForm.GMCT,
                RatePerGramCT: purchaseForm.RatePerGramCT,
                Purity: purchaseForm.Purity,
                PurcharType: result.PurchaseType,
                IsActive: result.IsActive === true ? 1 : 2,
                PurchaseFormChild:
                  purchaseForm.PurchaseFormChild?.map((child: any) => ({
                    ItemID: child.ItemID,
                    Weight: child.Weight,
                    StonePcs: child.StonePcs,
                    CTWeight: child.CTWeight,
                    Charges: child.Charges,
                    CustomeWeight: child.CustomeWeight,
                    ChargesForLable: child.ChargesForLable,
                  })) || [],
              }))
            : [],
      } as IPurchaseDetail;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Purchase By ID:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
// Delete a purchase
export const deletePurchase = createAsyncThunk(
  "PurchaseForm/DeletePurchaseForm",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PurchaseForm/DeletePurchaseForm`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Purchase deleted successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Deleting Purchase:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Get all active purchases
export const findAllActivePurchases = createAsyncThunk(
  "PurchaseForm/FindAllActivePurchaseForm",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/PurchaseForm/FindAllActivePurchaseForm`,
      );
      return response.data.Data;
    } catch (error: any) {
      console.error("Error Fetching Active Purchases:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Activate/Deactivate a purchase
export const purchaseActiveInactive = createAsyncThunk(
  "PurchaseForm/ActiveInActivePurchaseForm",
  async (formData: { ID: number; isActive: boolean }) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PurchaseForm/ActiveInActivePurchaseForm`,
        formData,
      );
      SuccessToast(response.data?.Details || "Status updated successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Updating Purchase Status:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
